import React, { useState, useEffect } from "react"
import {
  Typography,
  Button,
  TextField,
  Box,
  Input,
  Checkbox,
  Link,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Card,
  CardContent,
  Grid,
  Divider,
  FormControlLabel,
  Switch,
  alpha,
  useTheme,
} from "@mui/material"
import axios from "axios"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined"
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined"
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined"
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined"
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined"
import { LoadingOverlay } from "components/LoadingOverlay"

import { ImagePreview } from "styles/styledComponents"

import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import { baseURL } from "constants/api"
import { useStateContext } from "contexts/userContext"
import { useTranslation } from "react-i18next"
import { currencies } from "constants/constants"

// Карточка-секция с иконкой-заголовком в едином стиле дашборда
const SectionCard = ({ icon: Icon, title, color, children }) => (
  <Card sx={{ height: "100%" }}>
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: alpha(color, 0.12),
            color,
          }}
        >
          <Icon fontSize="small" />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
      </Box>
      {children}
    </CardContent>
  </Card>
)

export function Settings() {
  const [loading, setLoading] = useState(false)
  const [link, setLink] = useState("")
  const [textToOrder, setTextToOrder] = useState("")
  const [adminNumberTelegram, setAdminNumberTelegram] = useState("")
  const [notificationEmail, setNotificationEmail] = useState("")
  const [logoImage, setLogoImage] = useState("")
  const [showCreditCardButton, setShowCreditCardButton] = useState(false)
  const [showApplePayButton, setShowApplePayButton] = useState(false)
  const [showGooglePayButton, setShowGooglePayButton] = useState(false)
  const [showOrderButton, setShowOrderButton] = useState(false)

  const [showWaiterButton, setShowWaiterButton] = useState(false)
  const [showOnSiteOption, setShowOnSiteOption] = useState(false)
  const [showTakeAwayOption, setShowTakeAwayOption] = useState(false)
  const [showDeliveryOption, setShowDeliveryOption] = useState(false)
  const [currency, setCurrency] = useState(null) // Изначально null, т.к. валюта может не быть выбрана

  const [businessName, setBusinessName] = useState("")
  const [businessNameError, setBusinessNameError] = useState("")
  
  // Track if there are changes from initial values
  const [hasChanges, setHasChanges] = useState(false)
  const [initialValues, setInitialValues] = useState(null)

  const handleCurrencyChange = (e) => {
    const selectedCurrency = currencies.find((curr) => curr.code === e.target.value)
    setCurrency(selectedCurrency) // Сохраняем объект
  }

  const { t } = useTranslation()
  const theme = useTheme()

  const [alertDetail, setAlertDetail] = useState({
    isShow: false,
    severity: "error",
    message: t("This is an info alert — check it out!"),
  })

  const { restaurant_id, settings } = useStateContext()

  console.log("Settings_restaurantId :>> ", restaurant_id)
  console.log("settings :>> ", settings)

  const handleProductImageUpload = (e) => {
    const file = e.target.files[0]
    TransformFileData(file)
  }

  const TransformFileData = (file) => {
    const reader = new FileReader()

    if (file) {
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        setLogoImage(reader.result)
      }
    } else {
      setLogoImage("")
    }
  }

  const handleLinkChange = (e) => {
    setLink(e.target.value)
  }

  const handleTextToOrder = (e) => {
    setTextToOrder(e.target.value)
  }

  const handleAdminNumberTelegram = (e) => {
    setAdminNumberTelegram(e.target.value)
  }

  const handleNotificationEmailChange = (e) => {
    setNotificationEmail(e.target.value)
  }

  const handleBusinessNameChange = async (e) => {
    const value = e.target.value.trim()
    setBusinessName(value)
    setBusinessNameError("")
    // Проверка уникальности имени бизнеса отключена
    // if (!value) return
    // try {
    //   const resp = await axios.get(`${baseURL}/restaurants/check-business-name/${value}`)
    //   if (!resp.data.available) {
    //     setBusinessNameError(t("Это имя уже занято. Пожалуйста, выберите другое."))
    //   }
    // } catch (err) {
    //   setBusinessNameError(t("Ошибка проверки имени бизнеса"))
    // }
  }

  const saveChanges = async () => {
    if (!businessName) {
      setBusinessNameError(t("Business name is required"))
      return
    }
    if (businessNameError) return
    const dataToUpdate = {
      link: link,
      logoImage: logoImage,
      showCreditCardButton: !!showCreditCardButton,
      showApplePayButton: !!showApplePayButton,
      showGooglePayButton: !!showGooglePayButton,
      showOrderButton: !!showOrderButton,
      textToOrder: textToOrder,
      adminNumberTelegram: adminNumberTelegram,
      notificationEmail: notificationEmail,

      showWaiterButton: !!showWaiterButton,
      showOnSiteOption: !!showOnSiteOption,
      showTakeAwayOption: !!showTakeAwayOption,
      showDeliveryOption: !!showDeliveryOption,
      currency: currency || null, // Если не выбрана валюта, отправим null
      businessName: businessName,
    }

    console.log("dataToUpdate", dataToUpdate)
    try {
      const response = await axios.put(
        `${baseURL}/settings/${restaurant_id}`,

        dataToUpdate
      )
      console.log('Запрос "saveChanges" успешно выполнен')
      setLoading(false)

      // Update initial values after successful save
      setInitialValues({
        link,
        textToOrder,
        adminNumberTelegram,
        notificationEmail,
        logoImage,
        showCreditCardButton,
        showApplePayButton,
        showGooglePayButton,
        showOrderButton,
        showWaiterButton,
        showOnSiteOption,
        showTakeAwayOption,
        showDeliveryOption,
        currency,
        businessName,
      })
      setHasChanges(false)

      setAlertDetail({
        isShow: true,
        severity: "success",
        message: t("The operation was a success!"),
      })

      setTimeout(() => {
        setAlertDetail({
          ...alertDetail,
          isShow: false,
        })
      }, 5000)
    } catch (error) {
      setAlertDetail({
        isShow: true,
        severity: "error",
        message: t("The operation was a failure"),
      })

      setTimeout(() => {
        setAlertDetail({
          ...alertDetail,
          isShow: false,
        })
      }, 5000)

      setLoading(false)

      console.error('Ошибка при выполнении запроса "saveChanges":', error)
    }
  }

  useEffect(() => {
    if (restaurant_id !== null) {
      console.log("settings :>> ", settings)

      const showCreditCard = !!settings?.showCreditCardButton || false
      const showApplePay = !!settings?.showApplePayButton || false
      const showGooglePay = !!settings?.showGooglePayButton || false
      const showOrder = !!settings?.showOrderButton || false
      const showWaiter = !!settings?.showWaiterButton || false
      const showOnSite = !!settings?.showOnSiteOption || false
      const showTakeAway = !!settings?.showTakeAwayOption || false
      const showDelivery = !!settings?.showDeliveryOption || false
      
      const linkValue = settings?.link || ""
      const textToOrderValue = settings?.textToOrder || ""
      const adminNumberValue = settings?.adminNumberTelegram || ""
      const notificationEmailValue = settings?.notificationEmail || ""
      const logoImageValue = settings?.logoImage || ""
      const businessNameValue = settings?.businessName || ""

      setShowCreditCardButton(showCreditCard)
      setShowApplePayButton(showApplePay)
      setShowGooglePayButton(showGooglePay)
      setShowOrderButton(showOrder)

      setShowWaiterButton(showWaiter)
      setShowOnSiteOption(showOnSite)
      setShowTakeAwayOption(showTakeAway)
      setShowDeliveryOption(showDelivery)

      setLink(linkValue)
      setTextToOrder(textToOrderValue)
      setAdminNumberTelegram(adminNumberValue)
      setNotificationEmail(notificationEmailValue)
      setLogoImage(logoImageValue)

      // Устанавливаем объект валюты, если settings.currency содержит код валюты
      let currencyValue = null
      if (settings?.currency) {
        const foundCurrency = currencies.find((curr) => curr.code === settings.currency.code)
        currencyValue = foundCurrency || null
        setCurrency(currencyValue)
      } else {
        setCurrency(null)
      }

      setBusinessName(businessNameValue)

      // Store initial values for comparison
      setInitialValues({
        link: linkValue,
        textToOrder: textToOrderValue,
        adminNumberTelegram: adminNumberValue,
        notificationEmail: notificationEmailValue,
        logoImage: logoImageValue,
        showCreditCardButton: showCreditCard,
        showApplePayButton: showApplePay,
        showGooglePayButton: showGooglePay,
        showOrderButton: showOrder,
        showWaiterButton: showWaiter,
        showOnSiteOption: showOnSite,
        showTakeAwayOption: showTakeAway,
        showDeliveryOption: showDelivery,
        currency: currencyValue,
        businessName: businessNameValue,
      })
      
      setHasChanges(false)
    }
  }, [settings, restaurant_id])

  // Check for changes whenever any field updates
  useEffect(() => {
    if (!initialValues) return

    const currentValues = {
      link,
      textToOrder,
      adminNumberTelegram,
      notificationEmail,
      logoImage,
      showCreditCardButton,
      showApplePayButton,
      showGooglePayButton,
      showOrderButton,
      showWaiterButton,
      showOnSiteOption,
      showTakeAwayOption,
      showDeliveryOption,
      currency,
      businessName,
    }

    const changed = Object.keys(currentValues).some((key) => {
      if (key === "currency") {
        return currentValues[key]?.code !== initialValues[key]?.code
      }
      return currentValues[key] !== initialValues[key]
    })

    setHasChanges(changed)
  }, [
    initialValues,
    link,
    textToOrder,
    adminNumberTelegram,
    notificationEmail,
    logoImage,
    showCreditCardButton,
    showApplePayButton,
    showGooglePayButton,
    showOrderButton,
    showWaiterButton,
    showOnSiteOption,
    showTakeAwayOption,
    showDeliveryOption,
    currency,
    businessName,
  ])

  if (!loading && restaurant_id === null) {
    return <Typography>{t("You haven&apos;t created or chosen a restaurant yet")}</Typography>
  }


  // Переключатели опций доставки и оплаты, отрисовываемые в едином виде
  const toggleOptions = [
    {
      title: t("Delivery options"),
      icon: LocalShippingOutlinedIcon,
      color: theme.palette.success.main,
      items: [
        { label: t("On Site"), checked: showOnSiteOption, set: setShowOnSiteOption },
        { label: t("Take Away"), checked: showTakeAwayOption, set: setShowTakeAwayOption },
        { label: t("Delivery"), checked: showDeliveryOption, set: setShowDeliveryOption },
      ],
    },
    {
      title: t("Payment options"),
      icon: PaymentOutlinedIcon,
      color: theme.palette.secondary.main,
      items: [
        { label: t("Credit Card Button"), checked: showCreditCardButton, set: setShowCreditCardButton },
        { label: t("Apple Pay Button"), checked: showApplePayButton, set: setShowApplePayButton },
        { label: t("Google Pay Button"), checked: showGooglePayButton, set: setShowGooglePayButton },
        { label: t("Order Button"), checked: showOrderButton, set: setShowOrderButton },
      ],
    },
  ]

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "background.default", minHeight: "100vh" }}>
      {loading ? <LoadingOverlay /> : null}

      {/* Header */}
      <Box
        sx={{
          mb: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              mb: 1,
              color: "text.primary",
              fontSize: { xs: "2rem", md: "2.5rem" },
            }}
          >
            {t("Settings")} ⚙️
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {t("Configure your business, notifications and payment options")}
          </Typography>
        </Box>

        <Button
          variant="contained"
          color={hasChanges ? "primary" : "inherit"}
          onClick={saveChanges}
          disabled={!hasChanges || !!businessNameError}
          sx={{ minWidth: 140 }}
        >
          {t("Save")}
        </Button>
      </Box>

      <Grid container spacing={3}>
        {/* Основная информация */}
        <Grid item xs={12} md={6}>
          <SectionCard icon={TuneOutlinedIcon} title={t("General")} color={theme.palette.primary.main}>
            <Grid container spacing={2.5}>
              <Grid item xs={12}>
                <TextField
                  value={businessName}
                  onChange={handleBusinessNameChange}
                  label={t("Your business name")}
                  placeholder={t("Business name (e.g., new_biz)")}
                  variant="outlined"
                  fullWidth
                  error={!!businessNameError}
                  helperText={businessNameError}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={textToOrder}
                  onChange={handleTextToOrder}
                  label={t("Text to Order")}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>{t("Currency")}</InputLabel>
                  <Select
                    value={currency?.code || ""}
                    onChange={handleCurrencyChange}
                    label={t("Currency")}
                  >
                    <MenuItem value="">
                      <em>{t("Select currency")}</em>
                    </MenuItem>
                    {currencies.map((currencyOption) => (
                      <MenuItem key={currencyOption.code} value={currencyOption.code}>
                        {currencyOption.symbol} {currencyOption.code}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </SectionCard>
        </Grid>

        {/* Уведомления */}
        <Grid item xs={12} md={6}>
          <SectionCard
            icon={NotificationsActiveOutlinedIcon}
            title={t("Notifications")}
            color={theme.palette.warning.main}
          >
            <Grid container spacing={2.5}>
              <Grid item xs={12}>
                <TextField
                  value={adminNumberTelegram}
                  onChange={handleAdminNumberTelegram}
                  label={t("Chat ID in telegram")}
                  variant="outlined"
                  fullWidth
                  helperText={
                    <>
                      {t("You can define a chat_id using the following link")}:{" "}
                      <Link
                        href="https://t.me/username_to_id_bot"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        @username_to_id_bot
                      </Link>
                    </>
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={notificationEmail}
                  onChange={handleNotificationEmailChange}
                  label={t("Email for order notifications")}
                  variant="outlined"
                  fullWidth
                  type="email"
                  placeholder="example@email.com"
                />
              </Grid>
            </Grid>
          </SectionCard>
        </Grid>

        {/* Внешний вид / логотип */}
        <Grid item xs={12} md={6}>
          <SectionCard
            icon={ImageOutlinedIcon}
            title={t("Photo in Order")}
            color={theme.palette.info.main}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label htmlFor="imgUpload">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                >
                  {t("Upload")}
                </Button>
              </label>
              <Input
                id="imgUpload"
                type="file"
                inputProps={{
                  accept: "image/*",
                  style: { display: "none" },
                }}
                onChange={handleProductImageUpload}
                required
              />

              <ImagePreview>
                {logoImage ? (
                  <img src={logoImage} alt="error!" />
                ) : (
                  <p>{t("Image Preview")}</p>
                )}
              </ImagePreview>
            </Box>
          </SectionCard>
        </Grid>

        {/* Опции доставки и оплаты */}
        {toggleOptions.map((section) => {
          const Icon = section.icon
          return (
            <Grid item xs={12} md={6} key={section.title}>
              <SectionCard icon={Icon} title={section.title} color={section.color}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {section.items.map((item, idx) => (
                    <React.Fragment key={item.label}>
                      {idx > 0 && <Divider />}
                      <FormControlLabel
                        sx={{
                          m: 0,
                          py: 1,
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        labelPlacement="start"
                        control={
                          <Switch
                            checked={item.checked}
                            onChange={(e) => item.set(e.target.checked)}
                            color="primary"
                          />
                        }
                        label={
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {item.label}
                          </Typography>
                        }
                      />
                    </React.Fragment>
                  ))}
                </Box>
              </SectionCard>
            </Grid>
          )
        })}

        {/* Кнопка вызова официанта (отдельный переключатель) */}
        <Grid item xs={12} md={6}>
          <SectionCard
            icon={NotificationsActiveOutlinedIcon}
            title={t("Waiter Button")}
            color={theme.palette.error.main}
          >
            <FormControlLabel
              sx={{ m: 0, py: 1, justifyContent: "space-between", width: "100%" }}
              labelPlacement="start"
              control={
                <Switch
                  checked={showWaiterButton}
                  onChange={(e) => setShowWaiterButton(e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {t("Waiter Button")}
                </Typography>
              }
            />
          </SectionCard>
        </Grid>
      </Grid>

      {alertDetail.isShow && (
        <Box className="notification">
          <Alert severity={alertDetail.severity}>
            <AlertTitle>{t(alertDetail.severity)}</AlertTitle>
            {t(alertDetail.message)}
          </Alert>
        </Box>
      )}
    </Box>
  )
}
